import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeFilterBySort } from "../../features/filter/filterSlice";
import { fetchJobs } from "../../features/job/jobSlice";
import { sortByPrice } from "../../utlis/sortByPrice";
import Job from "./Job";

const Jobs = () => {
  const dispatch = useDispatch();
  const {
    job: { jobs, isLoading, isError, error },
    filter: { type: filterType, sortBy },
  } = useSelector((state) => state) || {};

  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  // decide what to show based on the state
  let content = null;
  if (isLoading) {
    content = <p className="text-center">Loading...</p>;
  }
  if (isError && error) {
    content = <p className="text-center">{error}</p>;
  }
  if (jobs.length === 0) {
    content = <p className="text-center">No jobs found</p>;
  }

  if (jobs.length > 0 && !isLoading && !isError) {
    content = sortByPrice(jobs, sortBy).map((job) => (
      <Job key={job.id} job={job} />
    ));
  }
  if (filterType !== "all") {
    const filteredJobs = sortByPrice(jobs, sortBy).filter(
      (job) => job.type === filterType
    );
    content = filteredJobs.map((job) => <Job key={job.id} job={job} />);
  }

  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="section-title">{`All Available ${
          filterType !== "all" ? filterType : ""
        } Jobs`}</h1>
        <div className="flex gap-4">
          <div className="search-field group flex-1">
            <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
            <input
              type="text"
              placeholder="Search Job"
              className="search-input"
              id="lws-searchJob"
            />
          </div>
          <select
            id="lws-sort"
            name="sort"
            autoComplete="sort"
            className="flex-1"
            onChange={(e) => dispatch(changeFilterBySort(e.target.value))}
          >
            <option value={"default"}>Default</option>
            <option value={"salary-low-to-high"}>Salary (Low to High)</option>
            <option value={"salary-high-to-low"}>Salary (High to Low)</option>
          </select>
        </div>
      </div>

      <div className="jobs-list ">{content}</div>
    </main>
  );
};

export default Jobs;
